export default __webpack_public_path__ + "static/media/battery.8e82f65e.svg";